"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATIC_PARTIAL_MYID_USERS = void 0;
const user_1 = require("../user");
let _STATIC_PARTIAL_MYID_USERS = [
    {
        given_name: 'Masha',
        family_name: 'Dowell',
        'id.sapID': 'DOWEM015',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Andrea',
        family_name: 'Trevino',
        'id.sapID': 'TREVA025',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Jamie',
        family_name: 'Park',
        'id.sapID': 'PARKJ297',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Kristen',
        family_name: 'Batko',
        'id.sapID': 'BATKK002',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Alejandra',
        family_name: 'Sabogal',
        'id.sapID': 'SABOJ012',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
    {
        given_name: 'Erik',
        family_name: 'Avellaneda',
        'id.sapID': 'AVELE004',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Colleen',
        family_name: 'Watson',
        'id.sapID': 'WATSC079',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Karisa',
        family_name: 'Bruin',
        'id.sapID': 'BRUIK002',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Sean',
        family_name: 'Costello',
        'id.sapID': 'COSTS046',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Kris',
        family_name: 'Miranda',
        'id.sapID': 'MIRAK021',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Sean',
        family_name: 'Persaud',
        'id.sapID': 'PERSS019',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Courteney',
        family_name: 'Merritt',
        'id.sapID': 'MERRC033',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'Melina',
        family_name: 'Ovanessian',
        'id.sapID': 'OVANM001',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Mara',
        family_name: 'Lucien',
        'id.sapID': 'SCHMM059',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Evan',
        family_name: 'Golden',
        'id.sapID': 'GOLDE043',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Nicole',
        family_name: 'Uchimura',
        'id.sapID': 'UCHIN002',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Scott',
        family_name: 'Morehead',
        'id.sapID': 'MORES103',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_QA],
    },
    {
        given_name: 'Alex',
        family_name: 'Niedt',
        'id.sapID': 'NIEDA009',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Lori',
        family_name: 'Huck',
        'id.sapID': 'HUCKL005',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Melissa',
        family_name: 'Mirch',
        'id.sapID': 'MIRCM003',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Sonya',
        family_name: 'Ellis',
        'id.sapID': 'ELLIS108',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Marchae',
        family_name: 'Miller',
        'id.sapID': 'MILLM501',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Andrew',
        family_name: 'Viera',
        'id.sapID': 'VIERA021',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Johanna',
        family_name: 'Evans',
        'id.sapID': 'EVANJ157',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Nicole',
        family_name: 'Hall',
        'id.sapID': 'HALLN044',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Ada',
        family_name: 'Douglass',
        'id.sapID': 'DOUGA073',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Evan',
        family_name: 'Marshall',
        'id.sapID': 'MARSE041',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Sinead',
        family_name: 'Persaud',
        'id.sapID': 'PERSS020',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Ivan',
        family_name: 'Tanev',
        'id.sapID': 'TANEI001',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'David',
        family_name: 'Pean',
        'id.sapID': 'PEAND001',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'Anna',
        family_name: 'Rybakov',
        'id.sapID': 'RYBAA003',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Isabel',
        family_name: 'Cava',
        'id.sapID': 'CAVAI007',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
    {
        given_name: 'Christian',
        family_name: 'Sanchez',
        'id.sapID': 'SANCC259',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
    {
        given_name: 'Deborah',
        family_name: 'Robins',
        'id.sapID': 'ROBID162',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
];
if (process.env.ENV_NAME !== 'prod') {
    _STATIC_PARTIAL_MYID_USERS = [
        ..._STATIC_PARTIAL_MYID_USERS,
        {
            given_name: 'Igor',
            family_name: 'Mishurin',
            'id.sapID': 'MISHI003',
            roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
        },
        {
            given_name: 'Agile',
            family_name: 'Mathew',
            'id.sapID': 'MATHA084',
            roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
        },
    ];
}
else {
    _STATIC_PARTIAL_MYID_USERS = [
        ..._STATIC_PARTIAL_MYID_USERS,
        {
            given_name: 'Igor',
            family_name: 'Mishurin',
            'id.sapID': 'MISHI003',
            roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
        },
    ];
}
_STATIC_PARTIAL_MYID_USERS.sort((a, b) => {
    const nameA = `${a.given_name} ${a.family_name}`;
    const nameB = `${b.given_name} ${b.family_name}`;
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
});
exports.STATIC_PARTIAL_MYID_USERS = _STATIC_PARTIAL_MYID_USERS;
//# sourceMappingURL=static-partial-myid-users.js.map